import { AwardTypeEmbeds, myAwardTypes } from '@kudos/http-client'
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

const MY_AWARDS_QK = 'myAwards'
const useMyAwards = (embeds: AwardTypeEmbeds[], enabled = true, awardTypeId?: string) => {
  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage, refetch } =
    useInfiniteQuery({
      queryKey: [MY_AWARDS_QK],
      queryFn: ({ pageParam }) =>
        myAwardTypes({
          embeds,
          idIn: awardTypeId ? [awardTypeId] : undefined,
          page: pageParam,
          pageSize: 20,
        }),
      enabled,
      initialPageParam: 1,
      getNextPageParam: lastPage => lastPage.next,
      placeholderData: keepPreviousData,
    })

  const awardTypesData = data ? data.pages.flatMap(page => page.results) : []

  return {
    awardTypesData,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    refetch,
  }
}

export default useMyAwards
